import { getIsGO } from '../../../1stlog-ui/src/utils/getIsGO'

export function getTrackingLink(
  barcode: string,
  trackingHash?: string,
): string {
  if (getIsGO()) {
    return generateGoTrackingLink(barcode)
  }

  if (!trackingHash) {
    console.warn("Tracking hash is missing, can't generate tracking link")
    return ''
  }

  return `${(global.tenantSettings.trackingUrl ?? '').replace(
    /\/$/,
    '',
  )}/lookup/${trackingHash}/coli/${barcode}`
}

function generateGoTrackingLink(input: string): string {
  const startIndex = input.length - 14
  const extractedPart = input.slice(startIndex, startIndex + 12)
  return `https://www.general-overnight.com/nld_nl/verzenden/verzending-volgen.html?reference=${extractedPart}`
}
